export const SYSTEM_LOCAL_STORAGE = {
  USER: 'user',
  CURRENT_ORGANIZATION_ID: 'currentOrganizationId',
}

export function setLocalStorageItem(key: string, value: string) {
  localStorage.setItem(key, value);
}

export function getLocalStorageItem(key: string): string | null {
  return localStorage.getItem(key);
}

export function removeLocalStorageItem(key: string) {
  localStorage.removeItem(key);
}